// Provider + contexto
export {
  ACLProvider,
  useACLContext,
  type ACLContextValue,
  type ACLProviderProps,
  type CheckOptions,
} from "./context";

// Hooks (primitivos + reatividade)
export * from "./hooks";

// Componentes declarativos
export {
  Can,
  Cannot,
  type CanProps,
  type CanBatchProps,
  type CanAsyncProps,
} from "./components";
